import PhasesService from '@/services/PhasesService.js';
import Vue from 'vue';

export const namespaced = true;

export const state = {
  colors: {}
};
export const mutations = {
  ADD_PHASE_COLORS(state, colors) {
    colors.forEach((color) => {
      Vue.set(state.colors, color.phaseId, color.hex);
    });
  }
};

export const actions = {
  fetchColors({ commit }) {
    return PhasesService.getPhasesColors()
      .then((response) => {
        commit('ADD_PHASE_COLORS', response.data);
      })
      .catch((err) => {
        console.error('Error: phases/getPhasesColors() failed', err);
      });
  }
};
